<template>
  <scroll-loading-list
    ref="momentListRef"
    :on-scroll-load="scrollLoad"
    :scroller="scrollableEl"
    class="min-h-full py-4"
  >
    <div class="flex justify-end pr-4" v-if="showCreate">
      <button
        class="btn btn-primary rounded btn-xs"
        @click="$router.push(`/thread/create`)"
      >
        {{ $t("MineMate.post") }}
      </button>
    </div>
    <div>
      <div class="px-2 pr-3">
        <thread-item1
          v-for="item in sortedMomentList"
          :key="item.uuid"
          :avatar-url="item.mate.mediaUrl"
          :chat-message-list="item.chatMessagezz"
          :content="item.text"
          :from-mate="item.fromMate"
          :gal-game="item.galGame"
          :has-next="item.childId != null"
          :has-prev="item.parentId != null"
          :impression-reactions="[]"
          :mate-id="item.mate.uuid"
          :mate-tone-id="item.mate.mateToneId"
          :media-list="item.mediazz"
          :mention-matezz="item.mentionMatezz"
          :moment="item"
          :reply="item.reply"
          :showCoinVote="true"
          :time="item.dtCreate"
          :title="item.mate.name"
          :type="item.mate.type"
          :uuid="item.uuid"
          :visibility="item.visibility"
          enable-audio-play
          @reaction-click="onActionClick(item)"
          @thread-click="
            () =>
              $router.push({
                name: 'threadDetail',
                params: { uuid: item.uuid },
              })
          "
        />
      </div>
    </div>
  </scroll-loading-list>

  <moment-actions
    v-model:show="showActions"
    :moment="toOperateMoment"
    @after-delete="onMomentDelete"
  />
</template>
<script setup lang="ts">
import { computed, onMounted, PropType, ref, UnwrapRef } from "vue";
import { ScrollLoadingListInstance } from "../ScrollLoadingList.vue";
import { PER_PAGE, useMoment } from "@/stores/moment";
import { Mate, Moment } from "@/types/entity";

const props = defineProps({
  mate: {
    type: Object as PropType<Mate>,
    required: true,
  },
  showCreate: {
    type: Boolean,
    default: true,
  },
});

const momentList = ref<Moment[]>([]);
const momentListRef = ref<ScrollLoadingListInstance | null>(null);
const scrollableEl = ref<HTMLElement | null>(null);
const momentStore = useMoment();
const scrollLoad = async () => {
  let cursor = undefined;
  if (momentList.value.length > 0) {
    cursor = momentStore.useCursorEncodeByCreate(
      momentList.value[momentList.value.length - 1].dtCreate!,
      true
    );
  }
  const moments = await momentStore.fetchMomentByMateId(
    props.mate.id!,
    cursor,
    undefined,
    undefined,
    { field: "dtCreate", order: "desc" }
  );
  if (moments.length === 0) return false;

  momentList.value.push(...moments);
  return moments.length === PER_PAGE;
};
const sortedMomentList = computed(() => {
  // 1. 将数组分为多个数组
  const arrSplitByRootId = momentList.value.reduce((acc, cur) => {
    if (acc.length === 0) {
      acc.push([cur]);
      return acc;
    }
    if (cur.childId !== null) {
      acc[acc.length - 1].push(cur);
    } else {
      acc.push([cur]);
    }
    return acc;
  }, [] as Moment[][]);
  // 2. 对每个数组进行排序
  arrSplitByRootId.forEach((arr) => {
    arr.sort((a, b) =>
      a.rootId || b.rootId
        ? new Date(a.dtCreate!).getTime() - new Date(b.dtCreate!).getTime()
        : new Date(b.dtCreate!).getTime() - new Date(a.dtCreate!).getTime()
    );
  });
  // 3. 合并数组
  return arrSplitByRootId.flat();
});

const showActions = ref(false);
const toOperateMoment = ref<Moment | null>(null);
const onActionClick = (moment: UnwrapRef<Moment>) => {
  toOperateMoment.value = moment;
  showActions.value = true;
};

const onMomentDelete = (uuid: string) => {
  momentList.value = momentList.value.filter((item) => item.uuid !== uuid);
};
onMounted(async () => {});
</script>
